import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import styles from './ReviewQualifiedRoleplay.module.css';
import { useGetRoleplayView } from 'features/roleplay/Roleplay.queries';
import QualifiedNavigationButtons from './QualifiedNavigationButtons';
import ShowRatingCriteria from './ShowRatingCriteria';
import ShowFeedback from './ShowFeedback';
import ScenarioHeader from './ScenarioHeader';
import RoleplayHeader from './RoleplayHeader';
import RoleplayVideo from './RoleplayVideo';
import { useRoleplayStore } from 'features/roleplay/Roleplay.store';
import ShowFilledWithAI from '../Autorating/ShowFilledWithAI';
import ShowRatingCriteriaIA from '../NewDescriptionRatingCriteria/ShowRatingCriteria';
import { useShouldShowAutoRating } from 'features/roleplay/RoleplayHooks';
import { useAutoFillStore } from '../Autorating/AutoFill.store';
import ReportResult from 'features/realplays/Components/ReportResult/ReportResult';
import { Skeleton } from '@material-ui/lab';
import NewReportResult from 'features/realplays/Components/ReportResult/NewReportResult';
import { useShouldShowNewIAReport } from 'features/realplays/RealPlaysHook';

const ReviewQualifiedRoleplay = () => {
  const { uuid } = useParams();
  const { data, isLoading } = useGetRoleplayView({ roleplay_id: uuid, enabled: !!uuid });
  const isEnabled = useShouldShowAutoRating();
  const { enabled: showNewReport, isLoading: isLoadingFlag } = useShouldShowNewIAReport();
  const secondAttempt = useRoleplayStore((state) => state?.secondAttempt);
  const hideSecondAttempt = useRoleplayStore((state) => state?.hideSecondAttempt);
  const closeShowDetails = useAutoFillStore((state) => state?.closeShowDetails);

  const scenarios = useMemo(() => data?.scenarios || [], [data]);
  const [selectedScenario, setSelectedScenario] = useState({});

  useEffect(() => {
    if (scenarios?.length <= 0) return;
    setSelectedScenario(scenarios[0]);
    hideSecondAttempt();
  }, [hideSecondAttempt, scenarios]);

  useEffect(() => {
    return () => {
      closeShowDetails();
    };
  }, [closeShowDetails]);

  const changeScenario = (increment = 1) => {
    try {
      hideSecondAttempt();
      const index = scenarios.findIndex((r) => r?.uuid === selectedScenario?.uuid);
      const newScenario = scenarios[index + increment];
      if (newScenario) setSelectedScenario(newScenario);
    } catch (error) {}
  };
  if (isLoading || isLoadingFlag)
    return (
      <div className={styles.mainContainer}>
        <Grid container direction="row" spacing={3}>
          <Grid item xs={12} lg={8}>
            <Skeleton
              variant="rect"
              width="100%"
              height="80vh"
              style={{ borderRadius: '0.5rem' }}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <Skeleton
              variant="rect"
              width="100%"
              height="80vh"
              style={{ borderRadius: '0.5rem' }}
            />
          </Grid>
        </Grid>
      </div>
    );

  return data?.interactive ? (
    showNewReport ? (
      <NewReportResult data={data || {}} />
    ) : (
      <ReportResult data={data || {}} />
    )
  ) : (
    <div className={styles.mainContainer}>
      <Grid container direction="row" spacing={3}>
        <Grid item xs={12} lg={8}>
          <div className={styles.card}>
            <RoleplayHeader roleplay={data} selectedScenario={selectedScenario} />
            <RoleplayVideo selectedScenario={selectedScenario} />
          </div>
        </Grid>
        <Grid item xs={12} lg={4}>
          <div className={styles.card}>
            <ScenarioHeader roleplay={data} />

            {!isEnabled ||
            selectedScenario?.response?.ai_raiting === false ||
            selectedScenario?.response_retake?.ai_raiting === false ? (
              <>
                <ShowRatingCriteria selectedScenario={selectedScenario} />
                <ShowFeedback
                  comment={
                    !secondAttempt
                      ? selectedScenario?.response?.comment
                      : selectedScenario?.response_retake?.comment || ''
                  }
                />
              </>
            ) : (
              <>
                <ShowRatingCriteriaIA selectedScenario={selectedScenario} />
                <ShowFilledWithAI
                  ai_feedback={
                    !secondAttempt
                      ? selectedScenario?.response?.comment
                      : selectedScenario?.response_retake?.comment || ''
                  }
                  ai_feedback_status={'SUCCEEDED'}
                />
              </>
            )}
            <QualifiedNavigationButtons
              changeScenario={changeScenario}
              scenarios={scenarios}
              selectedScenario={selectedScenario}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default ReviewQualifiedRoleplay;
